import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import ProductDetail from './components/ProductDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageProduct',
  components: {
    ProductDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;